var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagramGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.979 1.583h6.333V4.75H1.979zM1.979 14.25h6.333v3.167H1.979zM5.146 7.125v4.75M10.688 3.167h3.166V4.75M10.688 15.833h3.166V14.25M9.896 9.5l3.958-2.375L17.813 9.5l-3.959 2.375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramGrey);
export default __webpack_public_path__ + "static/media/diagram-grey.a492d7a9d4894400ce9a7367c0b1442a.svg";
export { ForwardRef as ReactComponent };